/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateGrantRequestBody
 */
export interface CreateGrantRequestBody {
    /**
     * The developer app address (API key) to grant authorization to
     * @type {string}
     * @memberof CreateGrantRequestBody
     */
    appApiKey: string;
}

/**
 * Check if a given object implements the CreateGrantRequestBody interface.
 */
export function instanceOfCreateGrantRequestBody(value: object): value is CreateGrantRequestBody {
    let isInstance = true;
    isInstance = isInstance && "appApiKey" in value && value["appApiKey"] !== undefined;

    return isInstance;
}

export function CreateGrantRequestBodyFromJSON(json: any): CreateGrantRequestBody {
    return CreateGrantRequestBodyFromJSONTyped(json, false);
}

export function CreateGrantRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateGrantRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'appApiKey': json['app_api_key'],
    };
}

export function CreateGrantRequestBodyToJSON(value?: CreateGrantRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'app_api_key': value.appApiKey,
    };
}

